import { Translation } from "../model/Translation";
import axiosInstance from "../utils/ApiUtils/axiosInstance";

// send a translation to  review phase
export const sendTranslationToReview = async (translationId: number): Promise<Translation> => {
  const response = await axiosInstance.post<{ data: Translation }>(`/api/translation/phase/send-to-review`, {
    translationId,
  });
  return response.data.data;
};
